import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoIcon, Loader2 } from 'lucide-react';

const TransactionStatusLoader = ({ transactionStatus }) => {
  if (!transactionStatus) return null;

  const { type, status, currentStep, progress, startedAt } = transactionStatus;

  const getStatusColor = () => {
    switch (status) {
      case 'PENDING': return '#fbbf24'; // yellow
      case 'IN_PROGRESS': return '#3b82f6'; // blue
      case 'SUCCESS': return '#10b981'; // green
      case 'ERROR': return '#ef4444'; // red
      default: return '#6b7280'; // gray
    }
  };

  const getStatusMessage = () => {
    if (status === 'ERROR') return `${type} Failed`;
    if (status === 'SUCCESS') return `${type} Complete`;

    // Show transaction type with "ing" suffix for active transactions
    if (type === 'SHIELD') {
      return status === 'PENDING' || status === 'IN_PROGRESS' ? 'Shielding...' : 'Shield Complete';
    }
    if (type === 'UNSHIELD') {
      return status === 'PENDING' || status === 'IN_PROGRESS' ? 'Unshielding...' : 'Unshield Complete';
    }

    // Fallback for other transaction types
    return `${type}...`;
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const started = new Date(timestamp);
    const diffMs = now - started;
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d ago`;
  };

  return (
    <div className="flex items-center gap-2 text-info">
      <div
        className="transaction-status-loader d-flex align-items-center gap-2 p-1 rounded"
        style={{
          // backgroundColor: `${getStatusColor()}20`,
          // border: `1px solid ${getStatusColor()}40`,
          // fontSize: '12px'
        }}
      >
        {(status === 'PENDING' || status === 'IN_PROGRESS') && (
          <Loader2
            size={14}
            className="animate-spin"
          // style={{ color: getStatusColor() }}
          />
        )}
        <span style={{ fontWeight: '400' }}>
          {getStatusMessage()}
        </span>
        {progress > 0 && (
          <span
          // style={{ color: getStatusColor() }}
          >
            ({progress}%)
          </span>
        )}
      </div>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`transaction-${transactionStatus.txHash}`}>
            <div className="text-left">
              <div><strong>{type} Transaction</strong></div>
              <div>Status: {status}</div>
              <div>Progress: {progress}%</div>
              <div>Started: {formatTimeAgo(startedAt)}</div>
              {transactionStatus.txHash && (
                <div className="text-xs mt-1">
                  Hash: {transactionStatus.txHash.slice(0, 10)}...
                </div>
              )}
            </div>
          </Tooltip>
        }
      >
        <InfoIcon size={16} />
      </OverlayTrigger>
    </div>
  );
};

export default TransactionStatusLoader;